import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import moment from 'moment';
import { themeGet } from '@styled-system/theme-get';
import Swal from 'sweetalert2';

import { TilesDigestDateInput } from './TilesDigestDateInput';
import Modal from '../../../shared/Modal';
import { Button } from '../../../shared/FormStyles/Button';

export const TileDigestCalendar = (props) => {
  const StyledParagraph = styled.p`
    font-size: 14px;
    font-family: 'Montserrat';
    font-weight: 400;
    color: ${themeGet('colors.black.80')};
    margin: 0 13px 16px;
    text-align: left;
  `;

  const StyledTitle = styled.h2`
    font-size: 20px;
    font-family: 'Montserrat';
    font-weight: 600;
    color: ${themeGet('colors.black.100')};
    margin: 0 13px 8px;
    text-align: left;
  `;

  const StyledDiv = styled.div`
    display: inline-block;
  `;

  const CalendarWrapper = styled.div`
    border: 1px solid ${themeGet('colors.black.10')};
    border-radius: 8px;
  `;

  const ButtonGroup = styled.div`
    display: flex;
    border-top: 1px solid ${themeGet('colors.black.10')};
    padding: 8px;
    margin: 16px 0 0;
    justify-content: flex-end;
  `;

  const openAddTilesDigestModal = () => {
    Modal({
      component: (
        <StyledDiv>
          <StyledTitle>{props.header}</StyledTitle>
          <StyledParagraph>{props.subHeader}</StyledParagraph>
          <CalendarWrapper>
            <TilesDigestDateInput
              value={props.value}
              onChange={props.onChange.bind(this)}
            />
            <ButtonGroup>
              <Button variant="tertiary" onClick={() => Swal.close()}>Cancel</Button>
              <Button
                variant="containedBlue"
                ml="8px"
                type="button"
                onClick={() => {
                  Swal.clickConfirm();
                }}
              >
                Save
              </Button>
            </ButtonGroup>
          </CalendarWrapper>
        </StyledDiv>
      ),
      width: '394px',
      padding: '24px 13px 16px',
    }).then(result => {
      if (result.value) {
        props.onConfirm(props.value);
      } else {
        props.onCancel();
      }
    });
  }

  return(
    <div>{openAddTilesDigestModal()}</div>
  )
}

TileDigestCalendar.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  header: PropTypes.string,
  subHeader: PropTypes.string,
  value: PropTypes.string,
  children: PropTypes.node,
  position: PropTypes.string,
};

TileDigestCalendar.defaultProps = {
  header: "",
  subHeader: "",
  value: moment().format('DD-MM-YYYY'),
  onCancel: () => null,
};
